import { render } from "./DashboardHosting.vue?vue&type=template&id=18b1b64d&scoped=true&ts=true"
import script from "./DashboardHosting.vue?vue&type=script&lang=ts"
export * from "./DashboardHosting.vue?vue&type=script&lang=ts"

import "./DashboardHosting.vue?vue&type=style&index=0&id=18b1b64d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b1b64d"]])

export default __exports__